import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { InstanceUserService } from 'src/app/services/instance-user.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {
  @Input() tallyId: string = ''
  @Input() subscriptionId: string = ''
  event : EventEmitter<any> =new EventEmitter()
  constructor(
    private modalService: BsModalService,
    public bsModalRef: BsModalRef,
    private instanceUserService: InstanceUserService,
    private authService: AuthService,
    private toasts: ToastrService
  ) { }

  ngOnInit(): void {
  }

  closedModal() {
    this.bsModalRef.hide();
  }

  logout() {
    this.authService.logout();
    this.closedModal();
  }
  changeTally() {
    const tallyChangePayload = {
      tallyId: this.tallyId,
      subscriptionId: this.subscriptionId
    }
    this.instanceUserService.releaseChange(tallyChangePayload).subscribe((res: any) => {
      if (res.success) {
        this.toasts.success(res.message)
        this.event.emit('ok');
        this.closedModal()
      }
    }, (error) => {
      this.closedModal()
      this.toasts.warning(error.error.message)
    })
  }

}
